import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TeltonikaDeviceReportingComponent } from '../teltonika-device/teltonika-device-reporting/teltonika-device-reporting.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { GenericTableHeaderComponent, GenericTableHeaderOptions } from '@huge-monorepo/shared/components';
import { SharedGenericSingletonService, SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import {
  ICustomerGenericService,
  ICustomerTeltonikaService, IHIPGenericService,
  IHIPTeltonikaService,
  TableHeader,
  Tag,
  TeltonikaSelectAllData,
} from '@huge-monorepo/shared/interfaces';
import { GenericService } from '@huge-monorepo/hip/services';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'huge-monorepo-teltonika-reporting',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule],
  templateUrl: './teltonika-reporting.component.html',
  styleUrl: './teltonika-reporting.component.scss',
})
export class TeltonikaReportingComponent {

  constructor(private router: Router, private route: ActivatedRoute) {

  }

  goToRoute(route: string) {
    this.router.navigate([route]);
  }

}
